import { fetchJSON } from "./base.service";

export const fetchBooks = async () => {
  const { data } = await fetchJSON({
    url: "/books",
  });

  return { data };
};
